'use client';

import {
  Box,
  Button,
  Grid,
  Typography,
} from '@mui/material';

import { useState } from 'react';
import { usePathname } from 'next/navigation';
import { sendGTMEvent } from '@next/third-parties/google';
import { searchHeadHeight, headerHeight, colorVariables } from '@/constants';
import theme from '@/theme';
import OverviewSection from '@/page-components/Vendor/OverviewSection';
import CategoryLocations from '@/page-components/Vendor/CategoryLocations';
import { Vendor } from '@/lib/types/interfaces/Vendor';
import LeadForm from '@/components/LeadForm';

const MainSection = ({ service }: { service: Vendor }) => {
  const [isLeadFormOpened, setIsLeadFormOpened] = useState(false);

  const pathname = usePathname();

  const handleRequestQuoteClick = () => {
    setIsLeadFormOpened(true);
    sendGTMEvent({
      url: pathname,
      event: 'click_on_service_provider_request_quote',
      service_provider_name: service.business_name,
    });
  };

  return (
    <Box
      sx={{
        paddingX: 3,
        paddingY: 3,
        marginTop: 0,
        [theme.breakpoints.up('lg')]: {
          paddingX: 18,
          paddingY: 3,
          minHeight: '50vh',
          marginTop: (searchHeadHeight + headerHeight) / 8,
        },
      }}
    >
      <Grid
        container
        spacing={3}
      >
        <Grid
          item
          xs={12}
          lg={9}
        >
          <OverviewSection service={service} />
        </Grid>
        <Grid
          item
          xs={12}
          lg={3}
          sx={{
            paddingTop: '0 !important',
            [theme.breakpoints.up('lg')]: {
              position: 'sticky',
              top: '220px',
              height: 'max-content',
            },
          }}
        >
          <Box
            display={{ xs: 'none', lg: 'block' }}
            pt={3}
            width={332}
          >
            <Box
              sx={{
                padding: 3,
                border: `1px solid ${colorVariables.separatorColor}`,
                borderRadius: '16px',
                background: 'white',
              }}
            >
              <Button
                variant='contained'
                color='success'
                sx={{
                  color: 'white',
                  minHeight: '42px',
                  width: '100%',
                }}
                onClick={handleRequestQuoteClick}
              >
                Request Quote
              </Button>
              <Typography
                marginTop={1}
                fontWeight={400}
                fontSize={12}
                lineHeight='20px'
                letterSpacing='0.38px'
                whiteSpace='nowrap'
                color={colorVariables.textDescription}
              >
                Get a fast, no obligation estimate for your project
              </Typography>
            </Box>
          </Box>

          <Box mt={{ xs: 0, lg: 3 }}>
            <CategoryLocations service={service} />
          </Box>
        </Grid>
      </Grid>
      <LeadForm
        open={isLeadFormOpened}
        onClose={() => setIsLeadFormOpened(false)}
        service={service}
      />
    </Box>
  );
};

export default MainSection;
